import { BrowserRouter } from "react-router-dom";
import ContextsProvider from "./contexts/provide";
import Routes from "@routes/index";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import ToastContainer from "@components/public/toast";
import { createEmotionCache, MantineProvider } from "@mantine/core";
import rtlPlugin from "stylis-plugin-rtl";
import { ModalsProvider } from "@mantine/modals";

const rtlCache = createEmotionCache({
    key: "mantine-rtl",
    stylisPlugins: [rtlPlugin],
});

const App = () => {
    const queryClient = new QueryClient();

    return (
        <BrowserRouter basename="/">
            <QueryClientProvider client={queryClient}>
                <ContextsProvider>
                    <MantineProvider
                        withGlobalStyles
                        withNormalizeCSS
                        theme={{
                            dir: "rtl",
                        }}
                        emotionCache={rtlCache}>
                        <ModalsProvider>
                            <section dir={"rtl"} className={"text-right rtl"}>
                                <ToastContainer
                                    rtl={true}
                                    position={"bottom-left"}
                                    autoClose={4000}
                                    theme="colored"
                                    hideProgressBar
                                    newestOnTop
                                    closeOnClick
                                    pauseOnFocusLoss
                                    draggable
                                    pauseOnHover
                                />

                                <Routes />

                                <div className="text-orange-500 text-green-500 text-gray-800 hidden" />
                            </section>
                        </ModalsProvider>
                    </MantineProvider>
                </ContextsProvider>
            </QueryClientProvider>
        </BrowserRouter>
    );
};

export default App;
